import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/general'],
  validationMode: 'any',
};

export const generalSettingsStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.GeneralSettings,
  category: PracticeSetupStepCategory.AdditionalSettings,
  title: 'Configure General Brand Settings',
  description: initRawSchema(
    `The General Brand Settings page contains a range of configuration options that influence how your practice operates day to day. Settings here affect appointment scheduling, treatment plan management, and your online booking experience. Review each option carefully and ensure everything is configured to your practice's preferences before going live.`
  ),
  dependsOn: [],
  getRoute: (brand, _practice) => `settings/brand/${brand.ref.id}/general`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason:
            'Please review the online booking settings before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
